import { useAuthStore } from '@/stores/auth.js'

export const useCheckPermission = (permiso) => {

  const authStore = useAuthStore()

  const hasPermission = authStore.permisos.includes(permiso);
  return {
    hasPermission
  }
}

// export function useCheckPermission() {
//   const authStore = useAuthStore()
//   const hasPermission = ref(false)

//   const makeRequest = async (permiso) => {
//     hasPermission.value = authStore.permisos.includes('permiso');
//   }

//   return {
//     hasPermission
//   }
// }
